import {
  CONSENT_CHOICES,
  CONSENT_COOKIE,
  CONSENT_MAX_AGE_S,
  type ConsentChoice,
} from '@lyrmo/shared';

// The visitor's choice about Lyrmo's own insights, kept in a cookie the API reads as well.

/** The choice the cookies keep; null before one is made, or once it has expired. */
export function readConsent(cookies?: string): ConsentChoice | null {
  let all = cookies;
  try {
    all ??= document.cookie;
  } catch {
    return null;
  }
  for (const part of all.split(';')) {
    const [name, value] = part.trim().split('=');
    if (name === CONSENT_COOKIE) return CONSENT_CHOICES.find((choice) => choice === value) ?? null;
  }
  return null;
}

/** Keeps the choice for six months, after which it's asked again. */
export function writeConsent(choice: ConsentChoice, protocol = window.location.protocol): void {
  const secure = protocol === 'https:' ? '; Secure' : '';
  try {
    document.cookie = `${CONSENT_COOKIE}=${choice}; Max-Age=${String(CONSENT_MAX_AGE_S)}; Path=/; SameSite=Lax${secure}`;
  } catch {
    // Cookies refused: the choice holds for this page alone, and nothing is told apart.
  }
}
